export default [
  {
    text: "低压非居民新装（增容）业务一次告知书",
    url: "/pdf/yewuBlzn/低压非居民新装（增容）业务一次告知书.pdf",
  },
  {
    text: "高压新装（增容）业务流程",
    url: "/pdf/yewuBlzn/高压新装（增容）业务流程.pdf",
  },
  {
    text: "高压新装（增容）业务一次告知书",
    url: "/pdf/yewuBlzn/高压新装（增容）业务一次告知书.pdf",
  },
  {
    text: "居民低压充电设施报装业务办理告知书",
    url: "/pdf/yewuBlzn/居民低压充电设施报装业务办理告知书.pdf",
  },
  {
    text: "居民客户分布式光伏并网业务办理告知书",
    url: "/pdf/yewuBlzn/居民客户分布式光伏并网业务办理告知书.pdf",
  },
  {
    text: "零星居民新装（增容）业务一次告知书",
    url: "/pdf/yewuBlzn/零星居民新装（增容）业务一次告知书.pdf",
  },
  {
    text: "企业客户分布式光伏并网业务办理告知书",
    url: "/pdf/yewuBlzn/企业客户分布式光伏并网业务办理告知书.pdf",
  },
  {
    text: "新建居住区供配电设施管理告知书",
    url: "/pdf/yewuBlzn/新建居住区供配电设施管理告知书.pdf",
  },
  {
    text: "用电业务办理告知书-暂停（暂停恢复）",
    url: "/pdf/yewuBlzn/用电业务办理告知书-暂停（暂停恢复）.pdf",
  },
  {
    text: "用电业务办理告知书-暂拆（复装）",
    url: "/pdf/yewuBlzn/用电业务办理告知书-暂拆（复装）.pdf",
  },
  {
    text: "用电业务办理告知书-移表",
    url: "/pdf/yewuBlzn/用电业务办理告知书-移表.pdf",
  },
  {
    text: "用电业务办理告知书-销户",
    url: "/pdf/yewuBlzn/用电业务办理告知书-销户.pdf",
  },
  {
    text: "用电业务办理告知书-迁址",
    url: "/pdf/yewuBlzn/用电业务办理告知书-迁址.pdf",
  },
  {
    text: "用电业务办理告知书-减容（减容恢复）",
    url: "/pdf/yewuBlzn/用电业务办理告知书-减容（减容恢复）.pdf",
  },
  {
    text: "用电业务办理告知书-过户",
    url: "/pdf/yewuBlzn/用电业务办理告知书-过户.pdf",
  },
  {
    text: "用电业务办理告知书-更名",
    url: "/pdf/yewuBlzn/用电业务办理告知书-更名.pdf",
  },
  {
    text: "用电业务办理告知书-改类",
    url: "/pdf/yewuBlzn/用电业务办理告知书-改类.pdf",
  },
  {
    text: "用电业务办理告知书-分户",
    url: "/pdf/yewuBlzn/用电业务办理告知书-分户.pdf",
  },
  {
    text: "用电业务办理告知书-并户",
    url: "/pdf/yewuBlzn/用电业务办理告知书-并户.pdf",
  },
  {
    text: "用电业务办理告知书-并户",
    url: "/pdf/yewuBlzn/用电业务办理告知书-并户.pdf",
  },
];
